// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "patient_auth".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "patient_auth" table (1:1 with a DB row, on the wire). */
export const patientAuthAtomSchema = z.object({
    id: z.string(),
    leadId: z.string(),
    organizationId: z.string(),
    customerAccountId: z.string(),
    lastLoginAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=patientAuth.js.map